export default "__VITE_ASSET__CYNesrur__"